import { readableText } from "../utils/themeContrast";
import React, { useEffect, useRef, useState } from "react";
import "../styles/styles.css";
import styled from "@emotion/styled";
import { ThemeContext, UserContext, ActionContext } from "../contexts/Context";
import CategorySearch from "./CategorySearch";
import { navigate } from '@reach/router';
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";

const MenuTopBar = ({
  width,
  itemList,
  setSelectedCategory,
  selectedCategory,
  category,
  setSelectedMenu,
  unlimitedScroll,
  selectedMenu,
  setLastPos,
  subCatObj,
  shouldExpand,
  isScrollDown,
  topCatType,
  headerHeight,
  takeawayOffset
}) => {
  //Stuff for List
  const [newList, setList] = useState([]);
  const [itemLen, setLen] = useState(0);
  useEffect(() => {
    //Stuff for List
    let newList = JSON.parse(JSON.stringify(itemList));
    setList(newList);
    let itemLen = itemList.length;
    setLen(itemLen);
  }, [itemList]);


  const [selectedIndex, setIndex] = useState(0);
  const [selectedSubIndex, setSubIndex] = useState(0);

  //Context
  const { company, lanIndex, isLanReverse, isSearching } = React.useContext(UserContext);
  const themeContext = React.useContext(ThemeContext);
  const { setScrolling } = React.useContext(ActionContext);

  const scrollToView = (element, isSub) => {
    //get view position
    if (element == null) return;
    let parentTop = 0;
    let parentElement = document.getElementById("menu_scroll");
    if (parentElement != null) {
      parentTop = parentElement.getBoundingClientRect().top;
    }
    let posTarget = element.getBoundingClientRect().top - (isSub ? 20 : -20) - parentTop - (topCatType == 1 ? 90 : 50);
    setScrolling(true);
    document.getElementById("menu_scroll").scrollBy({ top: posTarget });

    window.setTimeout(() => {
      setScrolling(false);
    }, 500);
  }
  useEffect(() => {
    if (unlimitedScroll) {
      window.setTimeout(() => {
       
        scrollToView(document.getElementById(category));
      }, 50);
    }
  }, []);

  useEffect(() => {
    setIndex(0);
    setSubIndex(0);
    let selectI = -1;
    let selectJ = -1;
    newList.forEach((nl, i) => {
      let mCat = nl.category;

      mCat = mCat.replaceAll("/", "").replaceAll("%", "");
      if (unlimitedScroll && selectedCategory) {
        if (mCat == selectedCategory.category) {
          setIndex(i);
          selectI = i;
        }
      } else if (category) {
        if (mCat == category) {
          setIndex(i);
          selectI = i;
        }
      }

      //searching for subcategory
      if (subCatObj[nl.category]) {
        let j = 0;
        for (let sc of subCatObj[nl.category]) {
          let mCat = sc.category;

          mCat = mCat.replaceAll("/", "").replaceAll("%", "");
          if (unlimitedScroll && selectedCategory) {
            if (mCat == selectedCategory.category) {
              setIndex(i);
              setSubIndex(j);
              selectI = i;
              selectJ = j;
            }
          } else if (category) {
            if (mCat == category) {
              setIndex(i);
              setSubIndex(j);
              selectI = i;
              selectJ = j;
            }
          }
          j++;
        }
      }
    });

    // if (selectedIndex == -1) return;
    if (newList.length > 0) {
      window.setTimeout(() => {
        //to revise
        if (document.getElementById("CAT" + selectI) == null) {
          return;
        }
        let screenOffset = 0;
        if (width > 550) {
          screenOffset = (width - 550) / 2
        }
        let left = document.getElementById("CAT" + selectI).getBoundingClientRect().left;
        document.getElementById("cat-scrollbars").scrollBy({ left: left - 24 - screenOffset });
        if (selectJ != -1 && document.getElementById("SCAT" + selectJ) != null) {
          let sLeft = document.getElementById("SCAT" + selectJ).getBoundingClientRect().left;
          document.getElementById('scat-scrollbars').scrollBy({ left: sLeft - 24 - screenOffset });
        }

      }, 50);

    }

  }, [newList, category, selectedCategory]);

  const handleDeccrease = () => {
    if (selectedIndex <= 0) return;
    setSelectedCategory(newList[selectedIndex - 1]);
    setSelectedMenu(null);

    let category = newList[selectedIndex - 1].category;
    if (unlimitedScroll) {
      setLastPos(0);
      scrollToView(document.getElementById(category), false);
      //scroll sub category
    }
    category = category.replaceAll("/", "");
    category = category.replaceAll("%", "");
    if (!unlimitedScroll)
      navigate('/menu/menu/' + category);
    else
      navigate('/menu');
  }
  const handleIncrease = () => {
    if (selectedIndex >= itemList.length - 1) return;
    setSelectedCategory(newList[selectedIndex + 1]);
    setSelectedMenu(null);

    let category = newList[selectedIndex + 1].category;
    if (unlimitedScroll) {
      setLastPos(0);
      scrollToView(document.getElementById(category), false);
    }
    category = category.replaceAll("/", "");
    category = category.replaceAll("%", "");
    if (!unlimitedScroll)
      navigate('/menu/menu/' + category);
    else
      navigate('/menu');
  }

  return (

    <React.Fragment>
      {!shouldExpand ?
        <div></div>
        :
        <React.Fragment>
          <SideBarContainer themeContext={themeContext} width={width} isScrollDown={isScrollDown} topCatType={topCatType} headerHeight={headerHeight} takeawayOffset={takeawayOffset}>
            {!isSearching && <>
            <IconButton onClick={() => handleDeccrease()}>
              <IoChevronBackOutline size={24} color="white" />
            </IconButton>
            <List
              id="cat-scrollbars"
              height={50}
              itemCount={newList.length}
              width={width}
            >
              {newList && newList.map((item, i) =>
                <Row
                  index={i}
                  data={{
                    setSelectedCategory: setSelectedCategory,
                    setSelectedMenu: setSelectedMenu,
                    selectedCategory: selectedCategory ? selectedCategory.category : "",
                    newList: newList,
                    themeContext: themeContext,
                    itemLen,
                    lanIndex,
                    isLanReverse,
                    unlimitedScroll,
                    scrollToView,
                    selectedMenu,
                    setScrolling,
                    setLastPos,
                    selectedIndex,
                    isScrollDown,
                    topCatType
                  }}
                />
              )}
            </List>
            <IconButton onClick={() => handleIncrease()}>
              <IoChevronForwardOutline size={24} color="white" />
            </IconButton>
            </>}
            <CategorySearch />
          </SideBarContainer>
          {(!isSearching && selectedIndex != -1 && newList.length > selectedIndex && subCatObj[newList[selectedIndex].category]) &&
            <SubCatContainer themeContext={themeContext} id="scat-scrollbars" isScrollDown={isScrollDown} topCatType={topCatType} headerHeight={headerHeight} takeawayOffset={takeawayOffset}>
              {subCatObj[newList[selectedIndex].category].map((item, j) =>
                <Row
                  index={j}
                  data={{
                    setSelectedCategory: setSelectedCategory,
                    setSelectedMenu: setSelectedMenu,
                    selectedCategory: selectedCategory ? selectedCategory.category : "",
                    newList: subCatObj[newList[selectedIndex].category],
                    themeContext: themeContext,
                    itemLen,
                    lanIndex,
                    unlimitedScroll,
                    scrollToView,
                    selectedMenu,
                    setScrolling,
                    setLastPos,
                    selectedIndex: selectedSubIndex,
                    isSub: true,
                    isScrollDown
                  }}
                />
              )}
            </SubCatContainer>
          }
        </React.Fragment>
      }
    </React.Fragment>
  );
};
export default React.memo(MenuTopBar);

const SubCatContainer = styled.ul`
  position: fixed;
  top: ${props => props.headerHeight + props.takeawayOffset + (!props.isScrollDown && props.topCatType == 1 ? 96 : 50)}px;
  display:flex;
  flex-grow:1;
  min-width: 0;
  overflow-x: auto;
  height: 32px;
  width: 100%;
  font-size: 12px;
  margin: 0px;
  padding-left: 0px;
  background-color: ${(props) => props.themeContext.topBarSubBg};
  z-index: 7;
  align-items: center;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  scroll-behavior: smooth;
  transition: top 0.2s ease;
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
const List = styled.ul`
  display: flex;
  flex-grow:1;
  overflow-x: auto;
 
  margin: 0px;
  padding-left: 0px;
  align-items: center;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
const IconButton = styled.div`
  @media (max-width: 767px) { display: none; }
`;

const Row = ({ index, data }) => {
  //Data passed as props to List Component

  const {
    newList,
    setSelectedCategory,
    setSelectedMenu,
    themeContext,
    lanIndex,
    isLanReverse,
    unlimitedScroll,
    scrollToView,
    setLastPos,
    selectedIndex,
    isSub,
    catImg,
    isScrollDown,
    topCatType
  } = data;

  let category = (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? newList[index].category : newList[index].category2 ? newList[index].category2 : newList[index].category;
  let isSelected = index == selectedIndex;

  return (
    <React.Fragment>
      {isSelected ?
        <CategorySelected
          themeContext={themeContext}
          finalItem={newList.length}
          isSub={isSub}
          isScrollDown={isScrollDown}
          index={index}
          id={(isSub ? "SCAT" : "CAT") + index}
          topCatType={topCatType}
        >
          <div style={{
            display: "flex",
            flexDirection: topCatType == 1 ? "column" : "row",
            alignItems: "center",
            justifyContent: "flex-start"
          }}>
            {!isSub && (topCatType == 1 || newList[index].catImg) &&
              <CategoryImg catImg={newList[index].catImg} isScrollDown={isScrollDown} topCatType={topCatType} />
            }
            <CategoryTxt topCatType={topCatType} isScrollDown={isScrollDown} hasImg={newList[index].catImg != ""}>{category}</CategoryTxt>
          </div>

        </CategorySelected>
        :
        <CategoryContainer
          id={(isSub ? "SCAT" : "CAT") + index}
          themeContext={themeContext}
          isSub={isSub}
          isScrollDown={isScrollDown}
          topCatType={topCatType}
          onClick={() => {
            setSelectedMenu(null);
            setSelectedCategory(newList[index]);

            let category = newList[index].category;
            if (unlimitedScroll) {
              setLastPos(0);
              scrollToView(document.getElementById(category), isSub);
            }
            category = category.replaceAll("/", "");
            category = category.replaceAll("%", "");
            if (!unlimitedScroll)
              navigate('/menu/menu/' + category);
            else
              navigate('/menu');
          }}
          finalItem={newList.length}
          index={index}
        >
          <div style={{
            display: "flex",
            flexDirection: topCatType == 1 ? "column" : "row",
            alignItems: "center",
            justifyContent: "flex-start"
          }}>
            {!isSub && (topCatType == 1 || newList[index].catImg) &&
              <CategoryImg catImg={newList[index].catImg} isScrollDown={isScrollDown} topCatType={topCatType} />
            }
            <CategoryTxt topCatType={topCatType} isScrollDown={isScrollDown} hasImg={newList[index].catImg != ""}>{category}</CategoryTxt>
          </div>

        </CategoryContainer>
      }
    </React.Fragment >
  );
};
const CategoryTxt = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* Show max 2 lines */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 13px;
  font-size: 12px;
  text-wrap: ${props => props.topCatType == 1 ? "wrap" : "nowrap"};
  width: ${props => props.topCatType == 1 ? "68px" : "none"};
  text-align: ${props => props.topCatType == 1 ? "center" : "left"};
  padding: ${props => props.topCatType == 1 ? "0px" : (props.hasImg ? "0px 16px 0px 8px" : "0px 16px")};
  height: ${props => props.topCatType == 1 && !props.isScrollDown ? "28px" : "none"};
  padding-top: ${props => props.topCatType == 1 && !props.isScrollDown ? "4px" : "none"};
`;
//Styled Component
const CategoryImg = styled.div`
  height: ${(props) => props.topCatType == 1 ? (props.isScrollDown ? 0 : 48) : 36}px;
  width: ${(props) => props.topCatType == 1 ? 48 : 36}px;
  border-radius: ${(props) => props.topCatType == 1 ? 24 : 18}px;
  
  background-image: url(${(props) => `https://ireachfnb.com${props["catImg"]}`});
  /*background-image: url(${(props) => `https://newdemo.chachingfnb.com${props["catImg"]}`});*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: height 0.1s ease;
`;
const CategorySelected = styled.li`
  position: relative;
  display: flex;
  font-size: ${props => props.isSub ? 12 : 14}px;
  font-family: ${(props) => props.themeContext.fontFamily};
  color: ${(props) => readableText(props.isSub ? props.themeContext.selectedSubCatBg : props.themeContext.selectedCatBg, props.themeContext.selectedCatColor, props.themeContext.topBarText, props.themeContext.cartFont)};
  align-items: center;
  white-space: nowrap;
  padding: ${props => props.topCatType == 1 ? "0 8px" : "0px"};
  height: ${(props) => props.isSub ? 30 : (!props.isScrollDown && props.topCatType == 1 ? 96 : 36)}px;
  background-color: ${(props) => props.isSub ? props.themeContext.selectedSubCatBg : props.themeContext.selectedCatBg};
  border-radius: ${props => props.topCatType == 1 ? 4 : 18}px;
  min-width: ${props => props.topCatType == 1 ? "68px" : "none"};
  transition: height 0.2s ease;
`;
const CategoryContainer = styled.li`
  display: flex;
  font-size: ${props => props.isSub ? 12 : 14}px;
  align-items: center;
  padding: ${props => props.topCatType == 1 ? "0 8px" : "0px"};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-weight: 500;
  color: ${(props) => readableText(props.isSub ? props.themeContext.topBarSubBg : props.themeContext.backgroundColor, props.themeContext.unselectedCategory, props.themeContext.fontPrimary)};
  white-space: nowrap;
  height: ${(props) => props.isSub ? 30 : (!props.isScrollDown && props.topCatType == 1 ? 96 : 36)}px;
  min-width: ${props => props.topCatType == 1 ? "68px" : "none"};
  transition: height 0.2s ease;
 `;

const SideBarContainer = styled.div`
  position: fixed;
  width: 100vw;
  top: ${(props) => props.headerHeight + props.takeawayOffset}px;
  transition: top 0.18s ease, height 0.2s ease;
  text-align: center;
  justify-content: flex-start;
  align-items: center;
  background-color: ${(props) => props.themeContext.backgroundColor};
  height:${(props) => !props.isScrollDown && props.topCatType == 1 ? 96 : 50}px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #9E9E9E;
  @media (max-width: 767px) {
    box-sizing: border-box;
    padding: 0 10px;
    background: ${(props) => props.themeContext.backgroundColor};
    border-bottom: 1px solid ${(props) => props.themeContext.borderColor || "#eee"};
  }
  z-index: 7;
`;
